// extracted by mini-css-extract-plugin
export default {"modal":"Trdd_KfkogsG4MjFfaE0","titleWrapper":"yBSfbzm0AQFY7Uzxav_k","paymentsDoneAlert":"skYseX41fbhNSBv1guSw","resetToOriginalAmountButton":"TAs_4hGENNIGFyMlchBP"};